// Generated by scripts/output-version-file.js

export const version: string = '2.2.3';
